import { NodeResults, RunDto } from "@custom-types/modelRun"
import EventFields from "@features/results/Result/ThresholdChartContainer/ThresholdForm/EventFields"
import { getDefaultFormValues } from "@features/results/Result/ThresholdChartContainer/ThresholdForm/helpers"
import { Grid } from "@mui/material"
import { GraphNodeData, GraphNodeEdgeData } from "@store/services/converter/types"
import { FormProvider, useForm } from "react-hook-form"
import { useEffect } from "react"

type EventValues = {
  node: string
  timestep: string
  operator: "<" | ">"
  boundary: number
}

// kk TODO: add validation schema and infer values type based on it
// export type ThresholdFormValues = InferType<typeof formValidationSchema>
export type ThresholdFormValues = {
  given_event: EventValues
  event: EventValues
}

type ThresholdFormProps = {
  graphData: GraphNodeEdgeData
  nodesData: GraphNodeData[]
  nodesResults: NodeResults
  run: RunDto
  onSubmit: (formValues: ThresholdFormValues) => void
  defaultGivenEventNodeLabel?: string
  defaultEventNodeLabel?: string
  showMinMaxBoundary?: boolean
  lag: number
}

const ThresholdForm = (props: ThresholdFormProps) => {
  const form = useForm<ThresholdFormValues>({
    defaultValues: getDefaultFormValues(
      props.nodesResults,
      props.lag,
      props.defaultGivenEventNodeLabel,
      props.defaultEventNodeLabel,
    ),
  })

  useEffect(
    () => {
      // submit on first render
      props.onSubmit(form.getValues())

      // submit on any form field change
      const { unsubscribe } = form.watch(() => props.onSubmit(form.getValues()))

      // clean up before unmounting component
      return unsubscribe
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
    [],
  )

  return (
    <FormProvider {...form}>
      <form autoComplete="off" noValidate>
        <Grid container direction="column" gap={2}>
          <Grid container wrap="nowrap" gap={3}>
            <Grid container item direction="column" gap={1} xs={6}>
              <EventFields
                graphData={props.graphData}
                prefixName="given_event"
                nodesData={props.nodesData}
                nodesResults={props.nodesResults}
                showMinMaxBoundary={props.showMinMaxBoundary}
                lag={props.lag}
              />
            </Grid>

            <Grid container item direction="column" gap={1} xs={6}>
              <EventFields
                graphData={props.graphData}
                prefixName="event"
                nodesData={props.nodesData}
                nodesResults={props.nodesResults}
                showMinMaxBoundary={props.showMinMaxBoundary}
                lag={props.lag}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}

export default ThresholdForm
